import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import { addDoc, collection, query, onSnapshot } from "firebase/firestore";
import { dbService } from "fbase";
import Navigation from "components/Navigation";
import Contact from "components/Contact";
import styles from "../components/Ordertable.module.css"
import '../components/styles.css'
import useTitle from "@nooks/use-title";
import { deleteDoc, doc, updateDoc } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Confirm({userObj, isLoggedIn}){
    useTitle("주문 확인");
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const {orderid} = useParams();
    const orderTextRef = doc(dbService, "orderlist", `${orderid}`);
    const [order, setOrder] =useState({});
    const [orderlist, setOrderlist] = useState([]);
    const getOrder = useCallback(() => {
        const q = query(collection(dbService, "orderlist"));
        onSnapshot(q, (snapshot) => {
            const orderArr = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setOrderlist(orderArr);  
            orderlist.map((order => order.id === orderid ? setOrder(order) : null))
        })
    }, [orderid, orderlist])
    useEffect(() => {
        getOrder();
    }, [getOrder])
    
    const [inputs, setInputs] = useState({
        name: "",
        email: "",
        phone: "",
        address: ""
    });

    const {name, email, phone, address} = inputs;

    useEffect(()=>{
        setInputs({
            name: order.name,
            email: order.email,
            phone: order.phone,
            address: order.address
        })
    }, [order.name, order.email, order.phone, order.address])

    const onChange = (e) => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]: value,
        })
    }

    const [rentaltime, setRentaltime] = useState("12:00:00")
    const getRentaltime = (event) => {
        setRentaltime(event.target.value);
    }

    useEffect(() => {
        setRentaltime(order.rentaltime);
    }, [order.rentaltime])

    const onDelete = async() => {
        const ok = window.confirm("주문을 취소하시겠습니까?");
        if(ok){
            const orderlogObj = {
                name: order.name,
                type: "주문취소",
                createdTime: Date.now()
            }
            await addDoc(collection(dbService, "orderlog"), orderlogObj);
            await deleteDoc(orderTextRef);
            window.location.replace(process.env.PUBLIC_URL + "/account");
        }
    }
    
    const [editing, setEditing] = useState(false);
    
    const [payment, setPayment] = useState(order.payment);
    const handleEditing = () => {
        setEditing(!editing);
        setPayment(order.payment)
    }
    const getPayment = () => {
        const checkPayment = document.getElementById("payment");
        if(checkPayment.checked){
            setPayment(true);
        } else {
            setPayment(false);
        }
    }
    const onSubmit = async (event) => {
        event.preventDefault();
        await updateDoc(orderTextRef, {
            name: name,
            email: email,
            phone: phone,
            rentaltime: rentaltime,
            address: address,
            payment: payment
        })
        setEditing(false);
    }
    // console.log(Date.parse(order.reservDate))
    return (
        <>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <div className={styles.pageWrapper}>
                <div className={styles.wrapper}>
                    <div className={styles.card}>
                        <div className={styles.cardBody}>
                            <h2 className={styles.title}>ORDER CONFIRM</h2>
                            <form>
                                <div className="d-flex justify-content-between">
                                    <div>
                                    {order.fbid ? 
                                        <Link to={process.env.PUBLIC_URL + `/product-detail/${order.fbid}`}>
                                            <h5 className="text-dark"><span name="cnumber">No.{order.cnumber}</span> {order.cname}</h5>
                                            <p className="small text-muted">{order.size}인치</p>  
                                        </Link>
                                        :
                                        <>
                                        <h5 className="text-dark"><span name="cnumber">No.{order.cnumber}</span> {order.cname}</h5>
                                        <p className="small text-muted">{order.size}인치</p>  
                                        </>
                                    }
                                    </div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-user" aria-hidden="true"></i> 이름</label>
                                            {editing ?
                                            <input
                                                className={styles.inputStyle4}
                                                type="text"
                                                name="name"
                                                id="username"
                                                onChange={onChange}
                                                value={name}
                                                required
                                            />
                                            :<h5>{order.name}</h5>}
                                        </div>
                                    </div>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-plane" aria-hidden="true"></i> 여행지</label>
                                            <h5>{order.nation} {order.city}</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-envelope" aria-hidden="true"></i> 이메일</label>
                                            {editing ?
                                            <input
                                                className={styles.inputStyle4}
                                                type="email"
                                                name="email"
                                                id="useremail"
                                                value={email}
                                                onChange={onChange}
                                                required
                                            />
                                            :<h5>{order.email}</h5>}
                                        </div>
                                    </div>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-mobile" aria-hidden="true"></i> 연락처</label>
                                            {editing ?
                                            <input
                                                className={styles.inputStyle4}
                                                name="phone"
                                                type="tel"
                                                id="userphone"
                                                value={phone}
                                                onChange={onChange}
                                                required
                                            />
                                            :
                                            <a href={`tel:${String(order.phone)}`} style={{color: "black"}}><h4>{order.phone}</h4></a>}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-calendar" aria-hidden="true"></i> 대여기간</label>
                                            <h6>{order.term}</h6>
                                        </div>
                                    </div>
                                    <div className={styles.col2}>
                                        <div>
                                            <label className={styles.label}>총 대여일</label>
                                            <h3>{order.days}일</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.row}>
                                {order.location ? (
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-map-marker" aria-hidden="true"></i> 대여장소</label>
                                            <h4>{order.location}</h4>
                                        </div>
                                    </div>
                                ):null}
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><FontAwesomeIcon icon="fa-solid fa-clock" /> 대여시간</label>
                                            {editing ? 
                                            <input
                                                type="time"
                                                id="time"
                                                name='time'
                                                className={styles.inputStyle4}
                                                value={rentaltime}
                                                min="10:00:00"
                                                max="22:00:00"
                                                onChange={getRentaltime}
                                            />
                                            :<h4>{order.rentaltime}</h4>}
                                        </div>
                                    </div>      
                                </div>                                  
                                <div className={styles.row}>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-suitcase" aria-hidden="true"></i> 미니캐리어</label>
                                            <h5>{order.mini ? (order.mini) : "추가 안 함"}</h5>
                                        </div>
                                    </div>
                                    <div className={styles.col2}>
                                        <div className={styles.inputGroup}>
                                            <label className={styles.label}><i class="fa fa-question-circle" aria-hidden="true"></i> 기타 요청사항</label>
                                            {editing ?
                                                <input
                                                    type="text"
                                                    name="address"
                                                    onChange={onChange}
                                                    value={address}
                                                    className={styles.inputStyle4}
                                                />
                                                :
                                                (<h5>{order.address}</h5>)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.row}>
                                {editing ?
                                    <div>
                                        <label className={styles.label}><i class="fa fa-question-circle" aria-hidden="true"></i> 입금여부</label>                                    
                                        <input id="payment" name="payment" type="checkbox" defaultChecked={payment} onClick={getPayment} value={payment} true />&nbsp;<label htmlFor="payment"><h5>입금확인</h5></label>
                                    </div>
                                    :
                                    (order.payment ?
                                    <div>
                                        <label className={styles.label}><i class="fa fa-check" aria-hidden="true"></i> 입금여부</label>
                                        <h5 className="paymentTrue">입금완료</h5>
                                    </div>
                                    : 
                                    <>
                                        <label className={styles.label}><i class="fa fa-check" aria-hidden="true"></i> 입금여부</label>
                                        <h5 className="paymentFalse">입금 전</h5>
                                        <p>농협 302-1739-7182-71 장주영</p>
                                    </>)
                                }
                                    <div style={{textAlign: "right"}}>
                                        <label className={styles.label}>총 대여가격</label>
                                        <h2>{order.price}</h2>
                                    </div> 
                                </div>
                                <div className="d-flex justify-content-between align-items-center" style={{marginTop:"2rem"}}>
                                    {userObj.email === "carryvilly@gmail.com" ?
                                    (editing ?
                                        <>
                                            <input type="button" className="btn btn-primary btn-xl edit" onClick={onSubmit} value="수정완료" />
                                            <button className="btn btn-primary btn-xl" onClick={handleEditing}>수정취소</button>
                                        </>
                                        :
                                        <>
                                            <input type="button" className="btn btn-primary btn-xl edit" onClick={handleEditing} value="수정" />
                                            <input type="button" className="btn btn-primary btn-xl deleteorder" value="주문취소" onClick={onDelete} />
                                        </>
                                        )
                                    :
                                    null
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Contact />
        </>
    )
}

export default Confirm;